// URL
export const PAYPAL_SDK = 'https://www.paypal.com/sdk/js';
export const PAYPAL_INIT = '/mcc-checkout/v2/paypal/init';
export const MYCHECKOUT_SAVED_PAYPAL = '/mycheckout/checkout?navigation=savedPayPal';
export const SIGN_IN = 'auth/view/checkout/signin';

// Paypal Tokens
export const LLC_PAYPAL_TOKEN = 'AdTVnAnEP2WGHYwQm0RouhLjlZfIr7EW6a0fdQlB0C0FEPpB_iDgvily1-JnAilEy-63ikS0gNjXC6pN';
export const PROD_PAYPAL_TOKEN = 'AQUolB5X1HACW19AGVFANA1SuuJOArLYtyJ0zI2yvD1jVxgUhZbl4E-m4ry_emlAEsik3xm4gcvKKL_B';